import Image from 'next/image';
import type { CSSProperties } from 'react';
import imageUrlBuilder from '@/lib/sanity/image-url-builder';

export default function SanityImage({
  className = undefined,
  disablePlaceholder = false,
  image,
  priority = false,
  sizes,
  style = undefined,
}: {
  className?: string;
  disablePlaceholder?: boolean;
  image: SanityImageWithAlt;
  priority?: boolean;
  sizes: string;
  style?: CSSProperties;
}) {
  if (!image || !image.asset) return null;

  const imageUrl = imageUrlBuilder.image(image).url();

  return (
    <Image
      className={className}
      src={imageUrl}
      alt={image.alt}
      width={image.asset.metadata?.width || 1}
      height={image.asset.metadata?.height || 1}
      loading={priority ? undefined : 'lazy'}
      placeholder={disablePlaceholder ? undefined : 'blur'}
      blurDataURL={image.asset.metadata?.lqip || ''}
      priority={priority}
      sizes={sizes}
      style={style}
    />
  );
}
